"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorageClearIdentity = exports.localStorageStoreIdentity = exports.localStorageGetIdentity = exports.createMessage = exports.SINGLE_SIGN_ON_TARGET = exports.Action = void 0;
// The possible typo of interactions with the iframe.
var Action;
(function (Action) {
    // Get the identity of a user.
    Action["GET"] = "get";
    // Store the identity of a user.
    Action["STORE"] = "store";
    // Clear the identity of a user.
    Action["CLEAR"] = "clear";
    // Check that the iframe can be communicated with.
    Action["PING"] = "ping";
})(Action || (exports.Action = Action = {}));
// Value used to identify messages intended for the iframe.
exports.SINGLE_SIGN_ON_TARGET = "single-sign-on";
// Helper function to create a message without the need of providing a target.
function createMessage(message) {
    return {
        target: exports.SINGLE_SIGN_ON_TARGET,
        ...message,
    };
}
exports.createMessage = createMessage;
// Get the identity of the user from local storage.
// Does some extra operations on the obtained value to make it more reliable.
function localStorageGetIdentity(user) {
    const item = localStorage.getItem(getKey(user));
    if (!item) {
        return null;
    }
    let identity;
    try {
        // If the item is not a valid JSON, we remove it.
        identity = JSON.parse(item);
    }
    catch (e) {
        localStorageClearIdentity(user);
        return null;
    }
    // The expiration is parsed as a string, so we need to convert it to a Date.
    identity.expiration = new Date(identity.expiration);
    // If expiration is in the past, we remove the identity.
    if (identity.expiration.getTime() <= Date.now()) {
        localStorageClearIdentity(user);
        return null;
    }
    // Everything is fine, we return the identity.
    return identity;
}
exports.localStorageGetIdentity = localStorageGetIdentity;
// Stores the identity of the user in local storage (if is not expired).
function localStorageStoreIdentity(user, identity) {
    const expiration = new Date(identity.expiration);
    if (expiration.getTime() > Date.now()) {
        localStorage.setItem(getKey(user), JSON.stringify(identity));
    }
}
exports.localStorageStoreIdentity = localStorageStoreIdentity;
// Clears the identity of the user from local storage.
function localStorageClearIdentity(user) {
    localStorage.removeItem(getKey(user));
}
exports.localStorageClearIdentity = localStorageClearIdentity;
// Gets the key where the identity of the user is stored in local storage.
function getKey(user) {
    if (!/^0x[a-fA-F0-9]{40}$/.test(user)) {
        throw new Error(`User must be a valid ethereum address`);
    }
    return `single-sign-on-${user.toLowerCase()}`;
}
//# sourceMappingURL=SingleSignOn.shared.js.map